import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
const common = {
  //管理员登录
  Login(params) {
    let postParam = {
      // userNameOrEmailAddress:'Ming_sTam@soonest.com',
      displayName: params.name,
      // uid:'3',
      password: params.pwd
    };
    return axios.post(`${base.dev}/TokenAuth/LoginInfo`, postParam);
  },
  //用户登录
  UserLogin(params) {
    let postParam = {
      // userNameOrEmailAddress:'Ming_sTam@soonest.com',
      displayName: params.name,
      // uid:'3',
      accessToken: params.accessToken,
      facebookId: params.userID,
      password: params.pwd
    };
    return axios.post(`${base.dev}/TokenAuth/AuthenticateLogin`, postParam);
  },
  //fb注冊
  fbLogin(params) {},
  //验证邮箱是否存在
  checkEmail(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/CheckEmail`, {
      params
    });
  },
  //重置密码
  resetPassWord(params) {
    return axios.post(
      `${base.dev}/services/app/MemEmber/ResetPassword`,
      params
    );
  },
  //發送郵件重置密碼
  resetPass(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/SendEmail`, { params });
  },
  //发送实名认证
  SendAuthEmail(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/SendAuthEmail`, {
      params
    });
  },
  //注册
  CustomerRegister(params) {
    let postParams = {
      sgL_UsersName: params.sgL_UsersName,
      sgL_LoginPassword: params.sgL_LoginPassword,
      sgL_LoginEmail: params.sgL_LoginEmail,
      sgL_Sex: params.sgL_Sex,
      sgL_Birth: params.sgL_Birth,
      sgL_Area: params.sgL_Area,
      isMessage: params.isMessage
    };
    return axios.post(`${base.dev}/services/app/MemEmber/Create`, postParams);
  },
  resetPass(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/SendEmail`, { params });
  },
  //我的留言
  reciverMessage(params) {
    return axios.get(`${base.dev}/services/app/Message/GetAll`, { params });
  },
  MessagePushAppSerivceGetAll(params) {
    return axios.get(`${base.dev}/services/app/MessagePushAppSerivce/GetAll`, {
      params
    });
  },
  MessagePushAppSerivceUpdateRead(params) {
    return axios.get(
      `${base.dev}/services/app/MessagePushAppSerivce/UpdateRead`,
      { params }
    );
  },
  deleteMsg(params) {
    return axios.delete(`${base.dev}/services/app/Message/Delete`, { params });
  },
  updateMsg(params) {
    return axios.post(`${base.dev}/services/app/Message/Update`, params);
  },
  getReciverMessagecountList(params) {
    return axios.get(`${base.dev}/services/app/Message/GetMessageCount`, {
      params
    });
  },
  //根据id获取会员信息
  getCustomerModel(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/Get`, { params });
  },
  //修改會員信息
  updateCustomerInfo(params) {
    return axios.post(`${base.dev}/services/app/MemEmber/Update`, params);
  },
  updatePw(params) {
    return axios.post(
      `${base.dev}/services/app/MemEmber/UpdatePassword`,
      params
    );
  },
  uploadUserImage(params) {
    return axios.post(`${base.dev}/TokenAuth/UploadUserImage`, params);
    //return axios.post(`${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=album`, params);
  },
  GetUserInfoById(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/GetById`, { params });
  },
  /**
   * @description : 根據用戶ID獲取獎牌信息
  */
  GetEventMedalsByUser(params) {
    return axios.get(`${base.dev}/services/app/MemEmber/GetEventMedalsByUser`, {
      params
    });
  },
  SiteSearch(params) {
    let reqUrl =
      base.dev.substring(0, base.dev.length - 3) + "Home/SearchResponse";
    return axios.get(`${reqUrl}`, { params });
  },
  oldLogin(params) {
    return axios.post(`${base.dev}/TokenAuth/Authenticate`, params);
  },
  RetryHangfire(params) {
    return axios.post(`${base.url}/Home/RetryHangfire`, params);
  },
  SetredisCache(params) {
    return axios.post(`${base.url}/Home/SetredisCache`, params);
  },
  GetredisCache(params) {
    return axios.post(`${base.url}/Home/GetredisCache`, params);
  },
};
export default common


// WEBPACK FOOTER //
// ./src/api/login/common.js